import type { ReactNode } from "react";
import type { Me } from "./api.js";
import styles from "./App.module.css";
import logo from "./assets/salesfix-logo.svg";

/**
 * The top bar from the reference tool: logo, tool name, page controls, and who is signed in. Client
 * participants are shown their own email address, which is how they signed in.
 */
export function AppHeader({ me, children }: { me?: Me; children?: ReactNode }) {
  return (
    <header className={`${styles.topbar} ${children ? styles.withTools : ""} no-print`}>
      <a href="/" className={styles.logoLink}>
        <img src={logo} alt="SalesFix" className={styles.logo} width={118} height={31} />
      </a>
      <div className={styles.toolName}>Value Map Builder</div>
      <div className={styles.spacer} />
      {children}
      {me && (
        <>
          <span className={styles.who}>Signed in as {me.name}</span>
          <form method="post" action="/auth/logout" className={styles.inline}>
            <button type="submit" className={styles.btn}>
              Sign out
            </button>
          </form>
        </>
      )}
    </header>
  );
}
